import { useRuntimeConfig } from 'nuxt/app';

export const fetchAllLocations = async () => {
    const config = useRuntimeConfig();

    const isDev = config.public.environment === 'dev';

    const baseUrl = isDev
        ? 'https://location-service-dev.ultimateperformance.com/all'
        : 'https://location-service.ultimateperformance.com/all';

    try {
        const response = await fetch(baseUrl);

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        return data.locations.filter(
            (location: { location_name: string }) =>
                location.location_name !== 'Liverpool'
        );
    } catch (error) {
        console.error('Error fetching locations:', error);
    }
};
